import MenuIcon from '@mui/icons-material/Menu';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import MainRouter from './main-route.component';
import { isNotNull } from './util.services';
import IButton from '../../components/button/i-button.component';
import { useNavigate } from 'react-router-dom';

const drawerWidth = "30%";

interface Props {
  window1?: () => Window;
}

function ResponsiveDrawer(props: Props) {
  const { window1 } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isClosing, setIsClosing] = React.useState(false);
  const navigate = useNavigate();

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  const goToUrl = (name: string, url: string) => {
    navigate(`/${url}`);
  }

  function createMenuList() {
    let menuList = [{ name: 'Amz Order', url: 'amazon/perf/order' },
                    { name: 'Amz Sale', url: 'amazon/perf/sale' },
                    { name: 'Sync Status', url: 'amazon/syncstatus' }];
    return menuList;
  }
  
  const menuList = createMenuList();

  function getMenu() {
    return (
        <List>
          {menuList.map((menu, index) => {
            return (
              <div key={menu.name}>
                <ListItemButton onClick={() => { goToUrl(menu.name, menu.url) }}>
                  <ListItemText primary={menu.name} />
                </ListItemButton>
              </div>
            );
          })}
        </List>
    );
  }

  const drawer = ( getMenu() );

  const container = window1 !== undefined ? () => window1().document.body : undefined;

  return (
    <>
      <AppBar position="fixed"
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div" className="app-title">
            LFH Home ERP System
          </Typography>
        </Toolbar>
      </AppBar>
      <Box sx={{ display: 'flex' }}>
        {/* <CssBaseline /> */}
        <Box
          component="nav"
          sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
          aria-label="mailbox folders"
        >
          {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onTransitionEnd={handleDrawerTransitionEnd}
            onClose={handleDrawerClose}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { xs: 'block', sm: 'none' },
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
          >
            {drawer}
          </Drawer>
          <Drawer
            variant="persistent"
            sx={{
              display: { xs: 'none', sm: 'block' },
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, marginTop: '65px' },
            }}
            open
          >
            {drawer}
            {isNotNull(null/*userData*/) && <div className="logout-btn">
              <IButton onActionEvent={() => {}} label='logout' variant="text" />
            </div>}
          </Drawer>
        </Box>
        <Box
          component="main"
          sx={{ flexGrow: 1, p: 3, width: { sm: `calc(95% - ${drawerWidth})` } }}
        >
          <MainRouter />
        </Box>
      </Box>
    </>
  );
}

export default ResponsiveDrawer
